import React from 'react';
import { Modal, Row, Col, List } from 'antd';
import moment from 'moment';

const ViewTask = ({ open, onClose, selectedIssue }) => {

  const attachmentsToShow = selectedIssue?.fileNames?.filter(file => file.status);

  return (
    <Modal
      open={open}
      title="Task Details"
      footer={null}
      onCancel={onClose}
      width="90%"
      style={{ top: 80 }}
    >
      {selectedIssue && (
        <div style={{ marginBottom: 32, padding: 16, background: '#f9f9f9', borderRadius: 8 }}>
          <Row gutter={[16, 12]}>
            <Col span={6}><strong>Task ID:</strong></Col>
            <Col span={6}>{selectedIssue.TaskID || '—'}</Col>

            <Col span={6}><strong>Priority:</strong></Col>
            <Col span={6}>{selectedIssue.Priority || '—'}</Col>

            <Col span={6}><strong>Task Title:</strong></Col>
            <Col span={6}>{selectedIssue.TaskTitle || '—'}</Col>

            <Col span={6}><strong>Tech Stack:</strong></Col>
            <Col span={6}>{selectedIssue.TechStack || '—'}</Col>

            <Col span={6}><strong>Dead Line:</strong></Col>
            <Col span={6}>{selectedIssue.Deadline || '—'}</Col>

            <Col span={6}><strong>Description:</strong></Col>
            <Col span={6}>{selectedIssue.issuedescription || '—'}</Col>

            <Col span={6}><strong>Created By:</strong></Col>
            <Col span={6}>{selectedIssue.CreatedBy || '—'}</Col>

            <Col span={6}><strong>Actual Hours Spent:</strong></Col>
            <Col span={6}>{selectedIssue.HoursSpent || '—'}</Col>

            <Col span={6}><strong>Created Date:</strong></Col>
            <Col span={6}>
              {selectedIssue.DateAndTime
                ? moment(Number(selectedIssue.DateAndTime)).isValid()
                  ? moment(Number(selectedIssue.DateAndTime)).format('DD/MM/YYYY')
                  : moment(selectedIssue.DateAndTime, moment.ISO_8601, true).isValid()
                    ? moment(selectedIssue.DateAndTime).format('DD/MM/YYYY')
                    : '—'
                : '—'}
            </Col>

            <Col span={6}><strong>Quality Score:</strong></Col>
            <Col span={6}>{selectedIssue.QualityScore || '—'}</Col>

            <Col span={6}><strong>Guided By:</strong></Col>
            <Col span={6}>{selectedIssue.GuidedBy || '—'}</Col>

            <Col span={6}><strong>Code Snippet</strong></Col>
            <Col span={6}>{selectedIssue.CodeSnippet || '—'}</Col>

            <Col span={6}><strong>Guide Notes</strong></Col>
            <Col span={6}>{selectedIssue.Instructions || '—'}</Col>

            <Col span={6}><strong>Remarks:</strong></Col>
            <Col span={6}>{selectedIssue.Remarks || '—'}</Col>

            <Col span={6}><strong>Assigned To:</strong></Col>
            <Col span={6}>{selectedIssue.Assignedto || '—'}</Col>

            <Col span={6}><strong>Final Remarks:</strong></Col>
            <Col span={6}>{selectedIssue.FinalRemarks || '—'}</Col>

            <Col span={6}><strong>Status:</strong></Col>
            <Col span={6}>{selectedIssue.Status || '—'}</Col>

            <Col span={6}><strong>Attachments:</strong></Col>
            <Col span={6}>
              {attachmentsToShow?.length > 0 ? (
                <List
                  size="small"
                  dataSource={attachmentsToShow}
                  renderItem={(file, idx) => (
                    <List.Item key={idx} style={{ border: 'none', padding: '4px 0' }}>
                      <a href={file.data} target="_blank" rel="noopener noreferrer">
                        {file.filename}
                      </a>
                    </List.Item>
                  )}
                />
              ) : (
                <span>No Attachments</span>
              )}
            </Col>
          </Row>
        </div>
      )
      }

    </Modal >
  );
};

export default ViewTask;
